import { render, staticRenderFns } from "./severance-report.vue?vue&type=template&id=40d81535"
import script from "./severance-report.vue?vue&type=script&lang=js"
export * from "./severance-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports